import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { LockKeyhole } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Switch } from '../ui/switch';
import { API_BASE } from '../../config/api';
import { useLearnerMode, setLearnerModeCache } from '../../hooks/useLearnerMode';

export default function LearnerModeCard({ token }) {
  const { programmesOnly, loaded } = useLearnerMode();
  const [saving, setSaving] = useState(false);

  const toggle = async (value) => {
    setSaving(true);
    try {
      await axios.put(`${API_BASE}/api/admin/platform/learner-mode`, { programmes_only: value }, { headers: { Authorization: `Bearer ${token}` } });
      setLearnerModeCache(value);
      toast.success(value ? 'Programmes-only learner mode ON' : 'Programmes-only learner mode OFF');
    } catch (e) {
      toast.error('Failed to update learner mode');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="bg-zinc-900 border-zinc-800 mb-6" data-testid="learner-mode-card">
      <CardContent className="py-5 flex items-center gap-4">
        <div className="h-10 w-10 rounded-lg bg-teal-500/15 flex items-center justify-center"><LockKeyhole className="h-5 w-5 text-teal-400" /></div>
        <div className="flex-1">
          <p className="text-white font-medium">Programmes-only learner mode</p>
          <p className="text-sm text-zinc-400">Learners only see Dashboard, Programmes and Profile. Admins are unaffected.</p>
        </div>
        <span className={`text-xs font-medium ${programmesOnly ? 'text-teal-300' : 'text-zinc-500'}`} data-testid="learner-mode-status">{programmesOnly ? 'ON' : 'OFF'}</span>
        <Switch checked={programmesOnly} disabled={!loaded || saving} onCheckedChange={toggle} data-testid="learner-mode-switch" />
      </CardContent>
    </Card>
  );
}
